import { withErrorBoundary } from 'components/common/MartyErrorBoundary';

import styles from 'styles/components/landing/melodyHeaderRule.scss';

export const MelodyHeaderRule = ({ slotDetails }) => {
  const { type, monetateId } = slotDetails;

  return (
    <hr className={styles.melodyRule} data-monetate-id={monetateId}>{type}</hr>
  );
};

export default withErrorBoundary('MelodyHeaderRule', MelodyHeaderRule);
